
export const base_url = "https://agri-shop-api.firinisan-agricultural.com/api/";
//export const base_url = process.env.REACT_APP_API_URL || "http://localhost:4000/api/";
